import React from 'react';
import { Helmet } from 'react-helmet-async';

const OG_IMAGE = 'https://images.unsplash.com/photo-1719760518176-e124a5bcd025?w=1200&h=630&fit=crop&q=80';
const SITE_NAME = 'Go Freestyle Studios';
const DOMAIN = 'https://gofreestyle.co.uk';

export default function SEO({ title, description, path, noindex = false }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Private Studios for Practitioners`;
  const desc = description || 'Private studios for independent health, wellbeing and beauty practitioners. Your own space to build your business.';
  const canonical = path ? `${DOMAIN}${path}` : '';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content="website" />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={OG_IMAGE} />
    </Helmet>
  );
}
